import { Component } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { RoutingPath } from 'mbs-ui-shared@constants';
import { AuthFacade } from 'mbs-ui-shared@facades/auth.facade';
import { LoginFacade } from 'mbs-ui-shared@facades/login.facade';
import { OAuthType } from 'mbs-ui-shared@models/OAuthCredential';
import { AppPersistentStateService, ConfigurationService } from 'mbs-ui-shared@services';
import { Observable, finalize } from 'rxjs';

@Component({
  selector: 'mbs-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent {
  public isMBSMode = true;
  public loadingPage = true;
  public loading$: Observable<boolean>;
  public authError = '';
  public oauthError = '';
  public vendor = '';

  public get isAgentLocal(): boolean {
    return this.auth.isAgentLocal;
  }

  constructor(
    private auth: AuthFacade,
    private loginFacade: LoginFacade,
    private router: Router,
    private appState: AppPersistentStateService,
    private config: ConfigurationService
  ) {
    this.loading$ = this.loginFacade.loading$;
    if (this.isAgentLocal) {
      this.isMBSMode = false;
      this.loadingPage = false;
    } else if (this.auth.onlineAccessKey) {
      this.isMBSMode = false;
      this.auth.onlineAccessInfo$.pipe(finalize(() => (this.loadingPage = false))).subscribe({
        next: (result) => {
          this.vendor = result?.info?.displayName;
        },
        error: () => {
          void this.router.navigateByUrl(RoutingPath.OnlineAccessNotFound);
        }
      });
    } else {
      this.loadingPage = false;
    }

    this.agentLocalMSOAuth();
  }

  onLoginSubmit(form: NgForm) {
    this.authError = '';
    if (form.valid) {
      this.loginFacade.login(form.value).subscribe({
        next: () => {
          localStorage.setItem('showForcePasswordRecovery', 'true');
          localStorage.setItem('showAllowOfflineEdit', 'true');

          if (this.isAgentLocal) return void this.router.navigateByUrl('');

          if (this.isMBSMode) {
            void this.router.navigateByUrl(RoutingPath.ApComputers);
            this.appState.resetState();
          } else {
            this.router.navigateByUrl(RoutingPath.OnlineAccess);
          }
        },
        error: (err) => (this.authError = err.error)
      });
    }
  }

  googleAuthClickHandler(): void {
    google.accounts.oauth2
      .initCodeClient({
        client_id: this.config.get('googleClientId'),
        scope: 'openid profile email',
        ux_mode: 'popup',
        callback: (response) => this.authByCode(response.code, OAuthType.google)
      })
      .requestCode();
  }

  msAuthClickHandler(): void {
    const params = new URLSearchParams({
      client_id: this.config.get('msClientId'),
      response_type: 'code',
      redirect_uri: location?.href,
      response_mode: 'query',
      scope: 'openid profile email'
    });

    window.location.href = `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?${params.toString()}`;
  }

  private authByCode(code: string, type: OAuthType): void {
    this.auth.getOAuthIdentity({ code, type }).subscribe({
      next: () => this.router.navigateByUrl(''),
      error: (err) => this.showOauthError(err.error)
    });
  }

  private showOauthError(error: string): void {
    this.oauthError = error;
    setTimeout(() => (this.oauthError = ''), 8000);
  }

  private agentLocalMSOAuth(): void {
    if (!this.isAgentLocal) return;

    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');

    if (code) this.authByCode(code, OAuthType.microsoft);
  }
}
